export default "__VITE_ASSET__DA1XD2vn__"